module.exports = require("dns");


//////////////////
// WEBPACK FOOTER
// external "dns"
// module id = 269
// module chunks = 0 1